<button
  *ngIf="raised"
  mat-raised-button
  [color]="color"
  (click)="openDialog(imageUrl, documentType)"
>
  <span i18n="@@uploadFile.buttonLabel">{text, select,
    other {{{ text }}}
  }</span>
</button>
<button
  *ngIf="!raised"
  mat-button
  [color]="color"
  (click)="openDialog(imageUrl, documentType)"
>
  <span i18n="@@uploadFile.buttonLabel"></span>
</button>
